import { GeneralService } from './../services/general.service';
import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-metawalls',
  templateUrl: './metawalls.component.html',
  styleUrls: ['./metawalls.component.css']
})
export class MetawallsComponent implements OnInit {

  
  constructor(private commonScriptComponent:CommonScriptComponent, private generalService:GeneralService ) { }
  base_url = this.generalService.BASE_URL;

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/metawalls/metawalls.component.ts